var render = function render(){var _vm=this,_c=_vm._self._c;return _c('d-modal-confirmation',{attrs:{"title":_vm.$t('contractors.delete.title'),"text":_vm.modalConfirmationText,"modal":_vm.modal,"isSubmitting":_vm.isSubmitting},on:{"submitModal":_vm.handleSubmitModal,"closeModal":_vm.handleCloseModal}})
}
var staticRenderFns = []

export { render, staticRenderFns }